export default "__VITE_ASSET__FyY$AC2r__"